import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "./i18n";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Fleet from "./pages/Fleet";
import CarDetail from "./pages/CarDetail";
import Booking from "./pages/Booking";
import Success from "./pages/Success";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Referral from "./pages/Referral";
import Neighborhood from "./pages/Neighborhood";
import Press from "./pages/Press";
import LiveFleet from "./pages/LiveFleet";
import DrivingDocs from "./pages/DrivingDocs";
import Loyalty from "./pages/Loyalty";
import Monthly from "./pages/Monthly";
import Welcome from "./pages/Welcome";
import Business from "./pages/Business";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import WhatsAppButton from "./components/WhatsAppButton";
import TawkChat from "./components/TawkChat";

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppButton />
      <TawkChat />
    </>
  );
}

function App() {
  return (
    <I18nProvider>
      <div className="App min-h-screen flex flex-col bg-[#050505] text-white">
        <BrowserRouter>
          <Routes>
            {/* Admin routes - no header/footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />

            {/* Public routes */}
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/fleet" element={<PublicLayout><Fleet /></PublicLayout>} />
            <Route path="/fleet/:carId" element={<PublicLayout><CarDetail /></PublicLayout>} />
            <Route path="/booking/:carId" element={<PublicLayout><Booking /></PublicLayout>} />
            <Route path="/booking/success" element={<PublicLayout><Success /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
            <Route path="/referral" element={<PublicLayout><Referral /></PublicLayout>} />
            <Route path="/rental/:city" element={<PublicLayout><Neighborhood /></PublicLayout>} />
            <Route path="/press" element={<PublicLayout><Press /></PublicLayout>} />
            <Route path="/live" element={<PublicLayout><LiveFleet /></PublicLayout>} />
            <Route path="/guide/driving-usa" element={<PublicLayout><DrivingDocs /></PublicLayout>} />
            <Route path="/loyalty" element={<PublicLayout><Loyalty /></PublicLayout>} />
            <Route path="/monthly" element={<PublicLayout><Monthly /></PublicLayout>} />
            <Route path="/welcome" element={<PublicLayout><Welcome /></PublicLayout>} />
            <Route path="/business" element={<PublicLayout><Business /></PublicLayout>} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0d0d0d",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "white",
            },
          }}
        />
      </div>
    </I18nProvider>
  );
}

export default App;
